import { combineReducers } from 'redux';
import { giveawaySelectedGiveawayReducerFactory } from 'swag-client-common/redux/partials/giveaway-selected/giveaway-selected.reducer';
import { shippingFormReducerFactory } from 'swag-client-common/redux/partials/shipping-form/shipping-form.reducer';
import { autocompleteReducer } from 'swag-client-common/redux/partials/autocomplete/autocomplete.reducer';
import { giveawaySelectedItemReducerFactory } from './reducers/giveaway-selected-item.reducer';
import { giveawayColorAndSizeVariantsReducerFactory } from './reducers/giveaway-color-and-size-variants.reducer';
import { GIVEAWAY_LANDING_STORE_PREFIX } from './giveaway-landing.actions';
import { giveawayLinkReducer } from './reducers/giveaway-link.reducer';
import { giveawayErrorReducerFactory } from './reducers/giveaway-error.reducer';
import { multipleProductsQuantitiesReducer } from './reducers/multiple-products-quantities.reducer';
import { multipleProductsQuantitiesStatusReducer } from './reducers/multiple-products-quantities-status.reducer';
import { touchedOrderReducer } from './reducers/touched-order.reducer';
export const giveawayLandingReducer = combineReducers({
  giveawayLink: giveawayLinkReducer,
  colorAndSizeVariants: giveawayColorAndSizeVariantsReducerFactory(GIVEAWAY_LANDING_STORE_PREFIX),
  selectedItems: giveawaySelectedItemReducerFactory(GIVEAWAY_LANDING_STORE_PREFIX),
  shippingData: shippingFormReducerFactory(GIVEAWAY_LANDING_STORE_PREFIX),
  autocomplete: autocompleteReducer,
  selectedGiveaway: giveawaySelectedGiveawayReducerFactory(GIVEAWAY_LANDING_STORE_PREFIX),
  error: giveawayErrorReducerFactory,
  multipleProductsQuantities: multipleProductsQuantitiesReducer,
  multipleProductsQuantitiesStatus: multipleProductsQuantitiesStatusReducer,
  touchedOrder: touchedOrderReducer
});